const PantoIcon = () =>
{
      return (
            <svg
                  width={16}
                  height={16}
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
            >
                  <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8 13.2667C10.9087 13.2667 13.2667 10.9087 13.2667 8C13.2667 5.0913 10.9087 2.73333 8 2.73333C5.0913 2.73333 2.73333 5.0913 2.73333 8C2.73333 10.9087 5.0913 13.2667 8 13.2667ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
                        fill="white"
                  />
                  <path d="M7.28906 0H8.61558V5.41899H7.28906V0Z" fill="white" />
                  <path
                        d="M16 7.17822L16 8.50474L10.4889 8.50474L10.4889 7.17822L16 7.17822Z"
                        fill="white"
                  />
                  <path
                        d="M5.51172 7.17822L5.51172 8.50474L0.000976505 8.50474L0.000976562 7.17822L5.51172 7.17822Z"
                        fill="white"
                  />
                  <path d="M7.28906 10.5811H8.61558V16H7.28906V10.5811Z" fill="white" />
            </svg>

      )
}

export default PantoIcon